import { mapPipelineStatus } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/pipelineStatus.utils';
import { pipelineStatusApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_PIPELINE_STATUS_ACTION_TYPE = createNamedActions(
  'commandCenterPipelineStatus',
  {
    SET_PIPELINE_STATUS: 'SET_PIPELINE_STATUS',
  },
);

export const getPipelineStatusAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await pipelineStatusApi.getMilestoneStatus({ config: SKIP_FORBIDDEN_CONFIG });

  return dispatch({
    type: COMMAND_CENTER_PIPELINE_STATUS_ACTION_TYPE.SET_PIPELINE_STATUS,
    payload: mapPipelineStatus(data ?? null),
  });
});
